/*
 *
 * MainLayout reducer
 *
 */
import produce from 'immer';
import { FLUSH_STATE } from './constants';

export const initialState = {
  loading: false,
  error: false
};

/* eslint-disable default-case, no-param-reassign */
const mainLayoutReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case FLUSH_STATE:
        return initialState;

    }
  });

export default mainLayoutReducer;
